import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import axAPI from "api/axios-instance";
import {
  AntiDopingMaterial,
  AntiDopingMaterialFormValues,
  AntiDopingMaterialsResponse,
} from "./types";

const MATERIALS_URL = "/cms/medicine/anti-doping/materials";

export const useAntiDopingMaterials = () => {
  const [materials, setMaterials] = useState<AntiDopingMaterial[]>([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [removingIds, setRemovingIds] = useState<number[]>([]);

  const loadMaterials = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axAPI.get<AntiDopingMaterialsResponse>(
        MATERIALS_URL
      );
      setMaterials(
        [...(data.materials || [])].sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0))
      );
    } catch (error: any) {
      message.error(
        error?.message || "Не удалось загрузить антидопинг материалы"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMaterials();
  }, [loadMaterials]);

  const saveMaterial = async (values: AntiDopingMaterialFormValues) => {
    setSaving(true);
    try {
      await axAPI.post(`${MATERIALS_URL}/upsert`, {
        ...values,
        ord: values.ord ?? undefined,
      });
      message.success("Материал сохранен");
      await loadMaterials();
    } catch (error: any) {
      message.error(error?.message || "Не удалось сохранить материал");
      throw error;
    } finally {
      setSaving(false);
    }
  };

  const removeMaterial = async (id: number) => {
    setRemovingIds((state) => [...state, id]);
    try {
      await axAPI.post(`${MATERIALS_URL}/remove/${id}`);
      message.success("Материал удален");
      await loadMaterials();
    } catch (error: any) {
      message.error(error?.message || "Не удалось удалить материал");
    } finally {
      setRemovingIds((state) => state.filter((item) => item !== id));
    }
  };

  return {
    loading,
    materials,
    removingIds,
    saving,
    removeMaterial,
    saveMaterial,
  };
};
